import { Badge, Button, Container, Navbar } from "react-bootstrap";
import axios from "axios";
import no_image from "../images/No_Image_Available.jpg";

import coverSample from "../images/No_Image_Available.jpg";
import Snapchat from "../images/snapchat.svg";
import Facebook from "../images/facebook-icon.svg";
import Twitter from "../images/twitter.svg";
import Instagram from "../images/instigram.svg";
import Global from "../images/global.svg";
import Whatsapp from "../images/whatsapp.svg";
import Map from "../images/map.svg";
import Tiktok_Light from "../images/tiktok_light.svg";

import SnapchatDarkTheme from "../images/snap-icon-dark-theme.svg";
import FacebookDarkTheme from "../images/facebook-icon-dark-theme.svg";
import TwitterDarkTheme from "../images/x-icon-dark-theme.svg";
import InstagramDarkTheme from "../images/insta-icon-dark-theme.svg";
import WhatsappDarkTheme from "../images/whatsapp-icon-dark-theme.svg";
import MapDarkTheme from "../images/map-dark-icon-theme.svg";
import GlobalDarkTheme from "../images/global-icon-dark-theme.svg";
import Tiktok_Dark from "../images/tiktok_dark.svg";
import { Box, FormControl, MenuItem, Select, SwipeableDrawer } from "@mui/material";
import {
	AllLanguagesCode,
	generateRandomToken,
	getAndSaveTimeZone,
	getAuth,
	setMobileBackColor,
	setMobileButttonBackColor,
	setMobileCardBorderColor,
	setMobileSettings,
	setMobileTextColor,
	setMobileTextField_BK_FONT_Border_StyleColor,
} from "../utility";
import { useQuery } from "react-query";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import Loading from "../common/loading";
import "../css/mobileScreens.css";
import i18next, { t } from "i18next";
import { useEffect, useState } from "react";
import ErrorDialog from "../common/errorDialog";
import MenuAvailabilityComponent from "../components/mobile screen/mobileComponents/MenuAvailabilityComponent";
import { ArrowLeftOutlined, ArrowRightOutlined, CloseOutlined, Person } from "@mui/icons-material";
import LoginComponent from "../components/mobile screen/mobileComponents/loginComponent";


const WellcomeScreen = ({ tableQr, tableName }) => {
	const [params, setParams] = useSearchParams();
	const navigate = useNavigate();

	const [loadingTree, setLoadingTree] = useState(false);
	const [drawerOpen, setDrawerOpen] = useState(false);
	const mobileLoginToken = localStorage.getItem("mobileLoginToken") || "";
	const [loginDialogOpen, setLoginDialogOpen] = useState(false);


	const handleOpenLoginDialog = (is_from_order) => {
		setLoginDialogOpen(true);
	};

	const handleCloseLoginDialog = () => {
		setLoginDialogOpen(false);
	};

	const handleVerificationSuccess = (token) => {
		if (token) {
			localStorage.setItem("mobileLoginToken", token || "");

		}
	};

	const checkLoginToken = () => {
		if (mobileLoginToken && mobileLoginToken?.length > 0) {
			return true;
		}
		return false;
	}
	const toggleDrawer = (open) => () => {
		setDrawerOpen(open);
	};
	const increaseScansCount = async () => {
		try {
			const response = await axios.post(
				`${process.env.REACT_APP_API}/menus/${tableQr}/increase-scans-count`,
				getAuth()
			);
		} catch (error) {
			console.error("Error increasing ScansCount:", error);
		}
	};


	useEffect(() => {
		if (!localStorage.getItem("gustToken")) {
			localStorage.setItem("gustToken", generateRandomToken(25));
		}

		getAndSaveTimeZone();

	}, []);

	const handleSocialPage = (data, type) => {
		if (type === "whatsapp") {
			const phoneNumber = data.replace(/\D/g, "");
			const message = "";
			const encodedMessage = encodeURIComponent(message);
			window.open(`https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodedMessage}`, "_blank");
		} else if (type === "map") {
			const lat = data[0];
			const long = data[1];
			window.open(`https://www.google.com/maps/search/?api=1&query=${lat},${long}`, "_blank");
		} else {
			window.open(data, "_blank");
		}
	};


	const onImageError = (e) => {
		e.target.src = coverSample;
	};


	const {
		data: languageData,
		isLoading: languageisLoading,
		isError: languageIsError,
		error: languageErrroPublic,
	} = useQuery("public-languages", () => {
		try {
			return axios.get(
				`${process.env.REACT_APP_API}/menus/${tableQr}/public-languages`
			);
		} catch (error) { }
	});

	const handleDefaultLang = () => {
		const language = AllLanguagesCode.filter((lang) => {
			return navigator.language.includes(lang);
		});

		if (language?.length > 0) {
			if (params.get("lang") && params.get("lang").length > 0) {

				i18next.changeLanguage(params.get("lang"));
				document.querySelector("html").lang = params.get("lang");
				localStorage.setItem("lang", params.get("lang"));
				if (params.get("lang") === "ar" || params.get("lang") === "fa") {
					document.body.classList.add("arabic-font");
					document.body.classList.remove("latino-font");
				} else {
					document.body.classList.add("latino-font");
					document.body.classList.remove("arabic-font");
				}
				return params.get("lang");
			}
		}

		if (!localStorage.getItem("lang")) {
			const selectedLanguage = language[0];
			var checkDefaultLang = languageData?.data.data.languages?.some(language => language.code === selectedLanguage)
			if (checkDefaultLang) {
				i18next.changeLanguage(selectedLanguage);
				document.querySelector("html").lang = selectedLanguage;
				localStorage.setItem("lang", selectedLanguage);
				if (selectedLanguage === "ar" || selectedLanguage === "fa") {
					document.body.classList.add("arabic-font");
					document.body.classList.remove("latino-font");
				} else {
					document.body.classList.add("latino-font");
					document.body.classList.remove("arabic-font");
				}
				return selectedLanguage;
			} else {
				i18next.changeLanguage(languageData?.data?.data?.languages[0]?.code);
				document.querySelector("html").lang = languageData?.data?.data?.languages[0]?.code;
				localStorage.setItem("lang", languageData?.data?.data?.languages[0]?.code);

				if (languageData?.data?.data?.languages[0]?.code === "ar" || languageData?.data?.data?.languages[0]?.code === "fa") {
					document.body.classList.add("arabic-font");
					document.body.classList.remove("latino-font");
				} else {
					document.body.classList.add("latino-font");
					document.body.classList.remove("arabic-font");
				}

				return languageData?.data?.data?.languages[0]?.code;
			}

		} else {
			return localStorage.getItem("lang");
		}
	};

	const handleLanguage = (event) => {
		const lang = event.target.value;
		i18next.changeLanguage(lang);
		document.querySelector("html").lang = lang;
		localStorage.setItem("lang", lang);
		params.set("lang", lang);

		if (lang === "ar" || lang === "fa") {
			document.body.classList.add("arabic-font");
			document.body.classList.remove("latino-font");
		} else {
			document.body.classList.add("latino-font");
			document.body.classList.remove("arabic-font");
		}
		setParams(params);
	};

	const handleLanguagedata = async (event) => {
		const lang = event.target.value;
		i18next.changeLanguage(lang);
		setLoadingTree(true);
		try {
			const timeZone = localStorage.getItem("timezone") || "";
			const promise = await axios.get(
				`${process.env.REACT_APP_API}/menus/${tableQr}/public-tree`,
				{
					headers: {
						localization: lang,
						timeZone: timeZone.replace(/["]+/g, ''),
					},
				}
			);

			await localStorage.setItem(
				"tree_data",
				JSON.stringify(promise?.data?.data ? promise?.data?.data : [])
			);
			handleLanguage(event);
		} catch (error) {
		} finally {
			setLoadingTree(false); // Hide progress dialog
		}
	};




	const {
		data: treeData,
		isLoading: treeDataIsLoading,
		isFetching: treeDataIsFetching,
		isError: treeDataIsError,
		error: treeDataError,
		refetch,
	} = useQuery("treeData", async () => {
		try {
			const language = AllLanguagesCode.filter((lang) => {
				return navigator.language.includes(lang);
			});
			var requestLang = "";

			const langData = await axios.get(
				`${process.env.REACT_APP_API}/menus/${tableQr}/public-languages`
			);

			if (!localStorage.getItem("lang")) {
				const selectedLanguage = language[0];
				var checkDefaultLang = langData?.data.data.languages?.some(language => language.code === selectedLanguage)
				if (checkDefaultLang) {
					requestLang = selectedLanguage;
				} else {
					requestLang = langData?.data?.data?.languages[0]?.code;
				}

			} else {
				requestLang = localStorage.getItem("lang");
			}

			const timeZone = localStorage.getItem("timezone") ? localStorage.getItem("timezone") : "";
			const promise = await axios.get(
				`${process.env.REACT_APP_API}/menus/${tableQr}/public-tree`,
				{
					headers: {
						localization: requestLang || localStorage.getItem("lang"),
						timeZone: timeZone.replace(/["]+/g, '')
					}
				}
			);
			if (promise.status === 200) {
				localStorage.setItem(
					"tree_data", JSON.stringify(promise?.data?.data ? promise?.data?.data : [])
				);
				setMobileSettings(promise?.data?.data?.details)
			}
			return promise;
		} catch (error) { }
	});


	if (treeDataError || languageIsError) {
		return <ErrorDialog />;
	}

	if (languageisLoading || treeDataIsLoading || loadingTree) {
		return <Loading backColor={setMobileBackColor()} />;
	}



	const EnterToSections = () => {
		navigate(
			`/${tableName}/${tableQr}/sections?section=0&t=${params.get(
				"t"
			)}&lang=${localStorage.getItem("lang")}`
		);
		increaseScansCount();
	}

	const navigateToPhoneNumberVerification = () => {
		navigate(`/${tableName}/${tableQr}/verify-phone?t=${params.get(
			"t"
		)}&lang=${localStorage.getItem("lang")}`);
	};

	return (
		<div
			className={`min-vh-100`}
			style={{
				backgroundColor:
					localStorage.getItem("theme") === "dark" ||
						localStorage.getItem("theme") === "costomize"
						? setMobileBackColor()
						: "",
				backgroundImage:
					localStorage.getItem("theme") === "dark" ||
						localStorage.getItem("theme") === "costomize"
						? setMobileBackColor()
						: "",
			}}
		>

			<div className="row p-0 m-0">
				<div className="col-lg-8 d-none d-lg-block">
					<div className="mt-5 text-center d-flex-justify-content-center align-items-center">
						<div style={{ marginTop: "15%", left: "25%", position: "fixed" }}>
							<img
								src={treeData?.data?.data?.details?.logo || no_image}
								className="me-4 slider-mobile-logo"
								style={{ width: "250px", height: "250px" }}
								onError={onImageError}

							/>
							<h1
								className="mt-4 head-font"
								style={{ color: setMobileTextColor() }}
							>
								{treeData?.data?.data?.details?.venu_name}
							</h1>
						</div>
					</div>
				</div>
				<div className="col-lg-4 ms-auto p-0">
					<div className="slider-mobile">
						<img
							src={
								treeData?.data?.data?.details?.cover
									? treeData?.data?.data?.details?.cover
									: no_image
							}
							onError={onImageError}
							className="slider-mobile-image"
						/>
						<Navbar
							className={`d-flex justify-content-space-between align-items-center mobile-top-nav alignByLang`}
							style={{
								backgroundColor:
									localStorage.getItem("theme") === "dark" ||
										localStorage.getItem("theme") === "customize"
										? setMobileBackColor()
										: "",
							}}
						>



							<Navbar.Brand className="text-center">
								{treeData?.data?.data?.details?.logo ? (
									<img
										src={treeData?.data?.data?.details?.logo || no_image}
										className="me-4 slider-mobile-logo"
										onError={onImageError}
									/>
								) : (
									<img
										src={no_image}
										className="me-4 slider-mobile-logo"
										onError={onImageError}
									/>
								)}
							</Navbar.Brand>

							{(treeData?.data?.data?.details?.is_available && !checkLoginToken()) && (
								<Button
									variant="outlined"
									disabled={!treeData?.data?.data?.details?.is_available || checkLoginToken()}
									className="m-top-12  head-font"
									onClick={() => handleOpenLoginDialog()}
									style={!treeData?.data?.data?.details?.is_available ? {
										color: setMobileTextColor(),

									} : {
										color: setMobileTextColor(),

									}}
								>
									<Person style={{ color: setMobileTextColor() }} />
								</Button>
							)}
						</Navbar>
					</div>
					<div className="wellcomeScreen">
						<Container>
							<div className="text-center" style={{ paddingLeft: "24px", paddingRight: "24px" }}>
								<h1
									className="mb-2 head-font"
									style={{ color: setMobileTextColor() }}
								>
									{JSON.parse(localStorage.getItem("tree_data"))?.details?.venu_name || treeData?.data?.data?.details?.venu_name}
								</h1>
								<p className="head-font" style={{ color: setMobileTextColor() }}>
									{JSON.parse(localStorage.getItem("tree_data"))?.details?.description || treeData?.data?.data?.details?.description}
								</p>
								<ul className="d-flex justify-content-center list-unstyled">
									{treeData?.data?.data?.details?.facebook && (
										<li className="mx-2">
											<img
												onClick={() =>
													handleSocialPage(treeData?.data?.data?.details?.facebook, 'facebook')
												}
												src={localStorage.getItem("theme") !== "light" ? FacebookDarkTheme : Facebook}
												alt="Facebook icon"
												className="cursor"
											/>
										</li>
									)}
									{treeData?.data?.data?.details?.public_whatsapp && (
										<li className="mx-2">
											<img
												style={{ width: "22px", height: "22px" }}
												onClick={() =>
													handleSocialPage(treeData?.data?.data?.details?.public_whatsapp, 'whatsapp')
												}
												src={localStorage.getItem("theme") !== "light" ? WhatsappDarkTheme : Whatsapp}
												alt="Whatsapp icon"
												className="cursor"
											/>
										</li>
									)}
									{treeData?.data?.data?.details?.instagram && (
										<li className="mx-2">
											<img
												onClick={() =>
													handleSocialPage(treeData?.data?.data?.details?.instagram, 'instagram')
												}
												src={localStorage.getItem("theme") !== "light" ? InstagramDarkTheme : Instagram}
												alt="Instagram icon"
												className="cursor"
											/>
										</li>
									)}
									{treeData?.data?.data?.details?.twitter && (
										<li className="mx-2">
											<img
												onClick={() =>
													handleSocialPage(treeData?.data?.data?.details?.twitter, 'twitter')
												}
												src={localStorage.getItem("theme") !== "light" ? TwitterDarkTheme : Twitter}
												alt="X icon"
												className="cursor"
											/>
										</li>
									)}
									{treeData?.data?.data?.details?.snapchat && (
										<li className="mx-2">
											<img
												onClick={() =>
													handleSocialPage(treeData?.data?.data?.details?.snapchat, 'snapchat')
												}
												src={localStorage.getItem("theme") !== "light" ? SnapchatDarkTheme : Snapchat}
												alt="Snapchat icon"
												className="cursor"
											/>
										</li>
									)}
									{treeData?.data?.data?.details?.website && (
										<li className="mx-2">
											<img
												onClick={() =>
													handleSocialPage(treeData?.data?.data?.details?.website, 'website')
												}
												src={localStorage.getItem("theme") !== "light" ? GlobalDarkTheme : Global}
												alt="global icon"
												className="cursor"
											/>
										</li>
									)}
									{treeData?.data?.data?.details?.tiktok && (
										<li className="mx-2">
											<img
												onClick={() =>
													handleSocialPage(treeData?.data?.data?.details?.tiktok, 'tiktok')
												}
												src={localStorage.getItem("theme") !== "light" ? Tiktok_Dark : Tiktok_Light}
												alt="global icon"
												className="cursor"
											/>
										</li>
									)}

									{(treeData?.data?.data?.details?.latitude && treeData?.data?.data?.details?.longitude) && (
										<li className="mx-2">
											<img
												style={{ width: "22px", height: "22px" }}
												onClick={() =>
													handleSocialPage([treeData?.data?.data?.details?.latitude, treeData?.data?.data?.details?.longitude], 'map')
												}
												src={localStorage.getItem("theme") !== "light" ? MapDarkTheme : Map}
												alt="Whatsapp icon"
												className="cursor"
											/>
										</li>
									)}
								</ul>

								<Box
									variant="standard"
									sx={{ margin: "auto", marginTop: "12px" }}
								>
									<FormControl fullWidth>
										<Select
											labelId="demo-simple-select-autowidth-label"
											id="demo-simple-select-autowidth"
											value={handleDefaultLang()}
											style={{ padding: "4px", borderRadius: "10px", borderColor: setMobileCardBorderColor(), borderWidth: 1, borderStyle: "solid" }}
											size="small"
											onChange={handleLanguagedata}
											sx={{
												backgroundColor: setMobileTextField_BK_FONT_Border_StyleColor()[0],
												color: setMobileTextField_BK_FONT_Border_StyleColor()[1], // Input background color
												borderColor: setMobileTextField_BK_FONT_Border_StyleColor()[2],
											}}
											MenuProps={{
												PaperProps: {
													style: {
														color: setMobileTextColor(),
														backgroundColor: setMobileBackColor(),
														borderColor: setMobileCardBorderColor(),
													},
												},
											}}
										>
											{languageData?.data.data.languages?.map((lang) => (
												<MenuItem
													value={lang.code}
													key={lang.code}
													className="sub-font"
												>
													{` ${t(lang.label)} ( ${lang.label} )`}
												</MenuItem>
											))}
										</Select>
									</FormControl>
								</Box>

								<Button
									// disabled={!treeData?.data?.data?.details?.is_available}
									className="form-control m-top-12 ps-3 pe-3 text-decoration-none head-font"
									onClick={() => EnterToSections()}
									style={{
										padding: "11px",
										color: "#426CA5",
										backgroundColor: "#E1EDFC",
										border: "none"
									}}
								>
									{t("Enter")}
								</Button>

								{/* {!treeData?.data?.data?.details?.is_available && (
									<p className="text-center text-danger mt-2 head-font">
										{t("This menu is not avialable")}
									</p>
								)} */}


								<div>
									<p
										className="text-center head-font alignByLang"
										style={{
											cursor: 'pointer',
											color: setMobileTextColor(),
											marginTop: "30px",
											marginBottom: "20%"
										}}
										onClick={toggleDrawer(true)}
									>
										{t("Opening hours")} {localStorage.getItem("lang") === "ar" || localStorage.getItem("lang") === "fr" ? <ArrowLeftOutlined /> : <ArrowRightOutlined />}
									</p>


									<SwipeableDrawer
										anchor="bottom"
										open={drawerOpen}
										onClose={toggleDrawer(false)}
										onOpen={toggleDrawer(true)}
									>
										<div
											style={{
												width: '100%',
												backgroundColor: setMobileBackColor(),
												position: 'relative' // Positioning context for close icon
											}}
											role="presentation"
										>
											<div className="alignByLang" style={{ paddingLeft: "20px", paddingRight: "20px", paddingTop: "25px" }}>
												<Badge
													className={`${localStorage.getItem("theme") === "dark" ? "waiting-badge-style-dark" : ""} p-2 font-size-18 sub-font m-1`}
												>
													{JSON.parse(localStorage.getItem("tree_data"))?.details?.menu_name || treeData?.data?.data?.details?.menu_name}

												</Badge>
											</div>

											<CloseOutlined
												className="alignByLang"
												onClick={toggleDrawer(false)}
												style={localStorage.getItem("lang") === "ar" || localStorage.getItem("lang") === "fr" ? {
													position: 'absolute',
													top: 10,
													left: 10,
													cursor: 'pointer',
													color: setMobileTextColor()
												} :
													{
														position: 'absolute',
														top: 10,
														right: 10,
														cursor: 'pointer',
														color: setMobileTextColor()
													}}
											/>
											<MenuAvailabilityComponent availability={treeData?.data?.data?.details?.availability} />
										</div>
									</SwipeableDrawer>
								</div>
							</div>

							<LoginComponent
								open={loginDialogOpen}
								handleCloseDialog={handleCloseLoginDialog}
								tableQr={tableQr}
								tableName={tableName}
								onVerificationSuccess={handleVerificationSuccess}
								is_from={1}
							/>
						</Container>
					</div>
				</div>
			</div >
		</div >
	);
};

export default WellcomeScreen;
